import { useEffect, useRef, useState } from "react";
import type { PumpPortalLiveRow } from "@/hooks/usePumpPortalTrades";
import { SVIXEngine, type SVIXSnapshot } from "@/lib/svixEngine";

export function useSvixEngine(liveRows: PumpPortalLiveRow[]) {
  const engineRef = useRef<SVIXEngine | null>(null);
  if (!engineRef.current) {
    engineRef.current = new SVIXEngine();
  }
  
  const [currentSvix, setCurrentSvix] = useState<SVIXSnapshot | null>(null);
  const processedRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    let latest: SVIXSnapshot | null = null;
    let changed = false;

    // Process only new rows
    for (const row of liveRows) {
      const id = `${row.id}-${row.ts}`;
      if (!processedRef.current.has(id)) {
        processedRef.current.add(id);
        latest = engineRef.current!.processRow(row);
        changed = true;
      }
    }

    if (changed && latest) {
      setCurrentSvix(latest);
    }
    
    // Prevent set from growing indefinitely
    if (processedRef.current.size > 1000) {
      const arr = Array.from(processedRef.current).slice(-500);
      processedRef.current = new Set(arr);
    }
  }, [liveRows]);

  return currentSvix;
}
